import { useDealContext } from '@openx/components-deal/lib/utils/context/DealContext';
import { useDebouncedValue } from '@openx/utils/hooks/useDebouncedValue';
import { useMemo } from 'react';
import { DEAL_SEARCH_DEBOUNCE_MS, DEAL_SEARCH_PAGE_SIZE } from '../utils/consts';
import type { DealOption } from '../utils/types';

// mirrors the OXS deal list (/deals) criteria so search results match what the user sees there
const buildDealSearchCriteria = (phrase: string) => ({
  filters: {
    byPhrase: { fields: ['name', 'exchange_deal_id', 'exchange_id'], phrase },
    byValue: [],
  },
  pagination: { pageNumber: 1, pageSize: DEAL_SEARCH_PAGE_SIZE },
  sort: { column: 'modified_date', direction: 'desc' },
});

export const useDealSearch = (phrase: string) => {
  const { useDealsLandingListFetch } = useDealContext();

  const trimmedPhrase = phrase.trim();
  const debouncedPhrase = useDebouncedValue(trimmedPhrase, DEAL_SEARCH_DEBOUNCE_MS);
  const criteria = useMemo(() => buildDealSearchCriteria(debouncedPhrase), [debouncedPhrase]);

  const { dealsList = [], loading } = useDealsLandingListFetch(criteria);
  const isSearchPending = trimmedPhrase !== debouncedPhrase || loading;
  const deals: DealOption[] = isSearchPending ? [] : dealsList;

  return { deals, isLoading: isSearchPending };
};
